const PREFIX = 'zoe.invite.k:';

function storageKey(token: string): string {
  return `${PREFIX}${token.slice(-24)}`;
}

// The head guard normally gets here first.
export function captureInviteContactKey(token: string | undefined): void {
  if (!token || typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  const key = url.searchParams.get('k');
  if (!key) return;
  try { window.sessionStorage.setItem(storageKey(token), key); } catch { /* storage blocked: the key only lives in this render */ }
  url.searchParams.delete('k');
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}

export function readInviteContactKey(token: string): string | null {
  try { return window.sessionStorage.getItem(storageKey(token)); } catch { return null; }
}

/** Header for an invite request whose token is in hand. */
export function inviteContactHeadersForToken(token: string): Record<string, string> {
  const key = token ? readInviteContactKey(token) : null;
  return key ? { 'X-Zoe-Contact-Key': key } : {};
}

/** Header for any request under /api/invites/:token. */
export function inviteContactHeaders(path: string): Record<string, string> {
  const match = /^\/api\/invites\/([^/?]+)/.exec(path);
  if (!match) return {};
  return inviteContactHeadersForToken(decodeURIComponent(match[1]!));
}
